// import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app';
import configureStore from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';
import ru_RU from 'antd/locale/ru_RU';

const { store, persistor } = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConfigProvider locale={ru_RU} theme={{
          //algorithm: theme.darkAlgorithm,
          token: {
            fontFamily: 'Open Sans',
            /* Согласовано с CSS: планшет с 745px, десктоп с 1401px (useBreakpoint / Grid) */
            screenSM: 745,
            screenMD: 768,
            screenLG: 992,
            screenXL: 1401,
            screenXXL: 1600,
            // colorPrimary: '#52c41a',         
            // colorPrimaryHover: '#73d13d',    
            // colorPrimaryActive: '#389e0d',   
          },
          components: {
            Form: {
              marginLG: 8,
              controlHeight: 28,
              labelHeight: 28,
              fontSize: 14,
              labelColonMarginInlineEnd: 0,
            },
          //   Table: {
          //     rowSelectedBg: "#e0efd5",
          //     headerBg: "#e0efd5",
          //     selectionColumnWidth: 16,
          //     rowExpandedBg: "#e0efd5",
          //   },
            // Button: {
            //   primaryColor: "#dddddd",
            //   defaultActiveBg: "#fff"
          //     defaultBg: "#ffffff",
          //     defaultColor: "#2f6f00",
          //     defaultHoverBg: "#2f6f00",
          //     defaultHoverColor: "#ffffff"
          //     // defaultBg: "#2f6f00",
          //     // defaultColor: "#ffffff",
            // }
          }
        }}
        >
    <App />
    </ConfigProvider>
      </PersistGate>
    </Provider>
);
